import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { card } from "./ui";

export default function Activity() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/activity").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-activity" className="max-w-3xl">
      <p className="text-gold/70 text-xs tracking-[0.25em] uppercase">Activity Log</p>
      <h1 className="font-serif text-4xl text-ivory mt-1 mb-6">Audit Trail</h1>
      <div className={`${card} p-5`}>
        <div className="space-y-1">
          {rows.map((a) => (
            <div key={a.id} className="flex items-start gap-3 py-2.5 border-b border-white/5 last:border-0">
              <span className="w-2 h-2 rounded-full bg-gold shrink-0 mt-1.5" />
              <div className="flex-1 min-w-0"><p className="text-ivory text-sm">{a.action}</p><p className="text-ivory/40 text-xs truncate">{a.detail}</p></div>
              <div className="text-right shrink-0"><p className="text-ivory/50 text-xs">{a.actor_name}</p><p className="text-ivory/30 text-[0.68rem]">{new Date(a.created_at).toLocaleString()}</p></div>
            </div>
          ))}
          {!rows.length && <p className="text-ivory/40 text-center py-8">No activity yet.</p>}
        </div>
      </div>
    </div>
  );
}
